
export default class ApiManager {
    
      // Cache time in milliseconds (default 5 minutes)
      static CACHE_TIME = 1 * 60 * 1000;
    
      // Try to get cached response, or return null if expired or missing
      static getCachedRequest(url, cacheTime = ApiManager.CACHE_TIME) {
        const cached = sessionStorage.getItem(url);
        if (!cached) return null;
    
        try {
          const { timestamp, data } = JSON.parse(cached);
          const now = Date.now();
          if (now - timestamp < cacheTime) {
            return data;
          } else {
            sessionStorage.removeItem(url); // Cache expired, remove it
            return null;
          }
        } catch (e) {
          // If parsing failed, remove corrupted cache
          sessionStorage.removeItem(url);
          return null;
        }
      }
    
      // Save response data to cache with timestamp
      static setCachedRequest(url, data) {
        const cacheEntry = {
          timestamp: Date.now(),
          data,
        };
        sessionStorage.setItem(url, JSON.stringify(cacheEntry));
      }
    
}